import React from "react";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../api/ApiSettings";

const initialState = {
    shippingMethods: [],
}
export const getShippingMethods = createAsyncThunk('shipping', async()=>{
    const response = await fetch(`${API_URL}shipping`, null)
    const data = await response.json(); 
    return data;
})


export const shippingMethodsSlice = createSlice({
    name: 'shipping',
    initialState,
    reducers:{ 
        setShippingMethod: (state,action)=>{
            state.shippingMethods = action.payload;
        }},
    
  extraReducers: {
   
    [getShippingMethods.fulfilled]: (state, action) => {
      state.shippingMethods = action.payload;
    },
   
  },
});

export const {setShippingMethod} = shippingMethodsSlice.actions;
export default shippingMethodsSlice.reducer;